module.exports = __webpack_public_path__ + "img/no-data-dark.bf36c7df.png";